import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginResult } from 'app/services/auth.service';
import { Logger } from 'app/shared/logger';
import { LoggerFactory } from 'app/shared/loggerFactory';

@Component({
  selector: 'psm-login',
  templateUrl: 'login.component.html',
  styleUrls: ['./userViews.scss']
})

export class LoginComponent {
  private logger: Logger;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    loggerFactory: LoggerFactory
  ) {
    this.logger = loggerFactory.create('LoginComponent');
  }

  public onLoginDone(result: LoginResult) {
    switch (result) {
      case LoginResult.Connected:
        this.route.queryParams.subscribe(params => {
          this.router.navigateByUrl(params.returnUrl || '/');
        });
        break;

      case LoginResult.EmailNotVerified:
        this.router.navigateByUrl('user/verifyEmail');
        break;

      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/user/login.component.ts